import React from 'react';
import { Button } from '@/components/ui/button';
import { Progress } from '@/components/ui/progress';
import { ArrowLeft } from 'lucide-react';

interface QuestionnaireHeaderProps {
  currentStep: 'quickInfo' | 'questionnaire' | 'summary' | 'emailOnly' | 'verifyEmail' | 'profileInfo' | 'createPassword' | 'dashboard';
  onClose: () => void;
}

export const QuestionnaireHeader: React.FC<QuestionnaireHeaderProps> = ({ currentStep, onClose }) => {
  const getProgress = () => {
    switch (currentStep) {
      case 'quickInfo': return 20;
      case 'questionnaire': return 50;
      case 'summary': return 100;
      case 'emailOnly': return 65;
      case 'verifyEmail': return 75;
      case 'profileInfo': return 85;
      case 'createPassword': return 95;
      case 'dashboard': return 100;
      default: return 0;
    }
  };

  const getStepText = () => {
    switch (currentStep) {
      case 'quickInfo': return 'Basic Information';
      case 'questionnaire': return 'Medical & Eligibility Questions';
      case 'summary': return 'Your Quote Summary';
      case 'emailOnly': return 'Email Verification';
      case 'verifyEmail': return 'Check Your Email';
      case 'profileInfo': return 'Profile Information';
      case 'createPassword': return 'Create Password';
      case 'dashboard': return 'Your Dashboard';
      default: return '';
    }
  };

  return (
    <div className="bg-background border-b">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center space-x-4">
            <Button 
              variant="ghost" 
              size="sm" 
              onClick={onClose}
              className="hover:bg-accent"
            >
              <ArrowLeft className="h-4 w-4 mr-2" />
              Back
            </Button>
            <div className="flex items-center space-x-2">
              <img 
                src="/lovable-uploads/0a3243f2-c9d9-43be-8f37-54dd1750981b.png" 
                alt="Safurra" 
                className="h-6 w-6"
              />
              <span className="font-semibold text-foreground">Safurra</span>
            </div>
          </div>
          
          <div className="text-sm text-muted-foreground">
            {getStepText()}
          </div>
        </div>
        
        <div className="space-y-2">
          <div className="flex justify-between text-sm text-muted-foreground">
            <span>Progress</span>
            <span>{getProgress()}% Complete</span>
          </div>
          <Progress value={getProgress()} className="h-2" />
        </div>
      </div>
    </div>
  );
};